import React, {useState, useEffect, useContext} from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { phpPath } from "./config"; // adjust path if needed
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import { AppContext } from "./ContextVars";
import translations from './translations';

const Workouts = () => {

    const imagePath = "/images/products/";
    const navigate = useNavigate();
    const { language } = useContext(AppContext);
    const t = (key) => translations.Workouts[key]?.[language] || key;

    const [pageNumber, setPageNumber] = useState(1); // #added 4/4/25 TG
    const [itemsPerPage, setItemsPerPage] = useState(12); // #added 4/4/25 TG
    const [display, setDisplay] = useState("items"); // #added 4/4/25 TG
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [products, setProducts] = useState([]); // #added 4/4/25 TG

    // #state

    /*const products = [
      {
        product_id: 1,
        name: "Kettlebell",
        mainImage: `${imagePath}kettlebell-1.png`,
        images: [
          `${imagePath}kettlebell-1.png`,
          `${imagePath}kettlebell-2.png`,
          `${imagePath}kettlebell-3.png`,
        ],
        price: "$49.99",
        stock: 10,
        description: `
          <p><strong>A high-quality kettlebell</strong> for strength training.</p>
          <ul>
            <li>Ergonomic grip</li>
            <li>Rust-resistant finish</li>
            <li>Available in multiple weights</li>
          </ul>
          <p>💪 Perfect for beginners and pros alike.</p>
        `,
      },
      {
        product_id: 2,
        name: "Dumbbell",
        mainImage: `${imagePath}dumbbells-1.png`,
        images: [
          `${imagePath}dumbbells-1.png`,
          `${imagePath}dumbbells-2.png`,,
          `${imagePath}dumbbells-3.png`,
        ],
        price: "$29.99",
        stock: 5,
        description: `
          <p><strong>Adjustable dumbbells</strong> designed for compact home gyms.</p>
          <p>Features:</p>
          <ol>
            <li>Quick-lock system</li>
            <li>Rubber-coated handles</li>
            <li>Up to 25 lbs each</li>
          </ol>
        `,
      },
      {
        product_id: 3,
        name: "Musculos",
        mainImage: `${imagePath}muscles-1.png`,
        images: [
          `${imagePath}muscles-1.png`,
          `${imagePath}muscles-2.png`,
          `${imagePath}muscles-3.png`,
        ],
        price: "$29.99",
        stock: 20,
        description: `
          <p>Premium resistance bands to build muscle.</p>
          <p><em>Includes light, medium, and heavy options</em>.</p>
        `,
      },
    ];*/
    

    const fetchProductDetails = (product_id) => {
      const product = products.find(p => p.product_id === product_id);
      if (product) {
        setSelectedProduct(product);
        setSelectedImage(product.mainImage); // 🆕
        setDisplay('product');
      }
    };
    
  
    const handleBack = () => {
      setDisplay('items');
      setSelectedProduct(null);
    };
  
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const res = await fetch(`${phpPath}/get_products.php`, {
            method: 'POST'
          });
          const data = await res.json();
          setProducts(data);
        } catch (err) {
          console.error("Error fetching products:", err);
        }
      };
    
      fetchProducts();
    }, []);

    const handleClick = () => {

    }

    //------------------------------------
    // JSX
    //------------------------------------
    return (
      <div>
        <main>
          <AnimatePresence mode="wait">
            {/* #Items List */}
            {display === "items" && (
              <motion.div
                key="items-view"
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 40 }}
                transition={{ duration: 0.4 }}
              >
                <section id="workouts" className="section overlay tint-black-30 height-40vh">
                  <div className="section__content">
                    <h2 className="general-title">{t('title')}</h2>
                    <h2 className="font-size-20 color-gray-3">
                      {t('subtitle')}
                    </h2>
                  </div>
                </section>
    
                           {/* #Who Am I */}
            <section className="section bg-color-gray-12 noheight padding-bottom-100">
            <div className="section__content  margin-top-140">
                <div className="gdiv width-80 gap-10px">
                <h2 className="general-title text-align-left move-left text-shadow">
                    {t('freeWorkouts')}
                </h2>
                <div className="general-description text-align-left move-left text-shadow margin-top-20">
                    {t('freeWorkoutsIntro')}
                <ol>
                    <li className="margin-top-40">
                      <span dangerouslySetInnerHTML={{ __html: t('step1') }} />
                      <ul className="sublist">
                          <li>{t('step1Sub1')}</li>
                          <li>{t('step1Sub2')}</li>
                      </ul>
                    </li>
                    <li className="margin-top-40">
                    {t('step2')}
                    <ul className="sublist">
                        <li>{t('step2Sub1')}</li>
                        <img src="./images/site/register-on-app-TG.png" alt="Register" className="img-responsive" />
                        <li className="margin-top-20" dangerouslySetInnerHTML={{ __html: t('step2Sub2') }} />
                        <li dangerouslySetInnerHTML={{ __html: t('step2Sub3') }} />
                    </ul>
                    </li>
                    <li className="margin-top-40">{t('step3')}
                      <img src="./images/site/open-workout.png" alt="Open Workout" className="img-responsive margin-top-10" />
                      </li>
                    <li className="margin-top-40">{t('step4')}
                    <ul className="sublist">
                        <li>{t('step4Sub1')}</li>
                        <img src="./images/site/all-public-workouts.png" alt="Register" className="img-responsive" />
                        <li className="margin-top-20">{t('step4Sub2')}</li>
                        <img src="./images/site/explore-more-workouts.png" alt="Register" className="img-responsive" />
                    </ul>
                    </li>
                </ol>
                </div>
                </div>


                <div className="gdiv width-80 gap-10px margin-top-100">
                <h2 className="general-title text-align-left move-left text-shadow">
                    {t('programTitle')}
                </h2>
                <div className="general-description text-align-left move-left text-shadow margin-top-20">
                  
                  
                <div className="responsive-player-wrapper margin-left-0">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=6P7Ngrsplw8"
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                    className="react-player-2"
                  />
                </div>
                  <p>{t('programDesc1')}</p>
                  <p className="margin-top-20">{t('programDesc2')}</p> 
                
                </div>
                <button className="button-2 move-left margin-top-10" onClick={()  => {navigate('/program')}}>
                  {t('goToProgram')}
                </button>

                </div>
            </div>
            </section>



              </motion.div>
            )}
    

          </AnimatePresence>
        </main>
      </div>
    );
    
};

export default Workouts;